/** ***********************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 ************************************************************************* */

import TranslationUtil from '../../translation';
import { APP_DIALOG } from '../../enums';

import { AppDialog, AppDialogDescription, AppDialogAction } from '../../../stores/dialog';

class DescriptionDialog {
    show(app, descriptionList) {
        if (!descriptionList || !descriptionList.length) {
            return;
        }
        const appDialog = new AppDialog({
            heading: TranslationUtil.getMessage('ccx.appDescription.header', { name: app.appFamilyName }),
            descriptionList: descriptionList.map(
                d => new AppDialogDescription(APP_DIALOG.DESCRIPTION_TYPE.LIST, d)
            ),
            onAction: () => appDialog.hide(),
            actionList: [
                new AppDialogAction({
                    actionId: 'close',
                    localizedText: TranslationUtil.getMessage('ccx.confirmation.btn.done'),
                    actionType: {
                        variant: 'cta',
                    },
                }),
            ],
        });
        appDialog.show({ immediate: true });
    }
}

export default new DescriptionDialog();
